export const formatSupportedFormats = (formats: string[]) => {
  if (formats.length === 1) {
    return `.${formats[0]}`;
  }

  if (formats.length === 2) {
    return `.${formats[0]} or .${formats[1]}`;
  }

  const firstFormats = formats
    .slice(0, -1)
    .map(format => `.${format}`)
    .join(', ');
  const lastFormat = `.${formats[formats.length - 1]}`;
  return `${firstFormats} or ${lastFormat}`;
};

export const formatFileSizeMB = (bytes: number) => {
  const mb = bytes / (1024 * 1024); // Convert bytes to megabytes
  return `${parseFloat(mb.toFixed(2))} MB`;
};

type UploadStateProps = {
  data: boolean;
  isUploading: boolean;
};

export const getUploadState = ({ isUploading, data }: UploadStateProps) => {
  if (isUploading) {
    return 'uploading';
  }
  if (data) {
    return 'uploaded';
  }

  return 'initial';
};

export const getRingtoneName = (name: string | File | null | undefined) => {
  if (!name) {
    return '';
  }
  if (typeof name === 'string') {
    return name;
  }
  return name.name;
};

export const getFileSize = async (url: string) => {
  try {
    const response = await fetch(url, { method: 'HEAD' });

    if (response.ok) {
      const contentLength = response.headers.get('Content-Length');

      return Number(contentLength ?? 0);
    }
    console.error(`Failed to retrieve file size. Status: ${response.status}`);
    return 0;
  } catch (error) {
    console.error('Error occurred. Could not make HEAD request to S3.', error);
    return 0;
  }
};
